import React from "react";
// import Modal from "../modal/modal.component";
import { Icon, Button, ThreeDotMenu } from "@alpaca/framework";
export default function EditInvitationButton({
  showCancelModal,
  showResendModal,
  showForceCreateModal,
}) {
  return (
    <>
      <div className="buttonWMenuContainer">
        {/* <button className="main btn">Edit</button>
      <button className="secondary btn">Delete</button> */}

        <Button onClick={(item) => showResendModal()}>Resend</Button>
        <ThreeDotMenu
          items={[
            {
              label: "Cancel",
              icon: <Icon icon="trash" className="icon-btn" />,
              onSelect: (item) => showCancelModal(),
            },

            {
              label: "Force Create",
              icon: <Icon icon="check" className="icon-btn" />,
              onSelect: (item) => showForceCreateModal(),
            },
          ]}
        />
      </div>
    </>
  );
}
